module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-b12146f6aa88ba672f034efcc6bb150a.webp";